import { NgModule } from '@angular/core';
import { SwiperModule } from 'swiper/angular';
import { SharedModule } from '../shared/shared.module';
import { VideoComponent } from './video.component';

@NgModule({
  imports: [SharedModule, SwiperModule],
  declarations: [VideoComponent],
  exports: [VideoComponent],
  providers: []

})
export class VideoModule { }
